'use client';

import logger from 'logger';
import { useEffect, useState } from 'react';

import { useAuthUser } from '~/auth';

export const useDriveFile = () => {
  const [fileContent, setFileContent] = useState<Blob>(new Blob());
  const [loading, setLoading] = useState(true);

  const { getToken } = useAuthUser();

  useEffect(() => {
    const fetchFile = async () => {
      const token = await getToken();

      if (!token) {
        logger.error('User is undefined');
        return;
      }
      const response = await fetch('/api/contracts', {
        headers: { Authorization: token, 'content-type': 'application/json' },
        method: 'GET',
      });

      if (response.ok) {
        const data = await response.blob();
        setFileContent(data);
        setLoading(false);
      } else {
        logger.error('Failed to fetch file');
      }
    };

    fetchFile();
  }, [getToken]);

  return { fileContent, loading };
};
